import apecImg from "assets/brandImages/apec.png";
import bayblendImg from "assets/brandImages/bayblend.png";
import makroblendImg from "assets/brandImages/makroblend.png";
import makrolonImg from "assets/brandImages/makrolon.png";

interface BrandUiConfig {
  image: string;
  accentColor: string;
}

export const BRAND_UI_CONFIG: Record<string, BrandUiConfig> = {
  Makrolon: { image: makrolonImg, accentColor: "#009fe4" },
  Apec: { image: apecImg, accentColor: "#00bb7e" },
  Bayblend: { image: bayblendImg, accentColor: "#7d55c7" },
  Makroblend: { image: makroblendImg, accentColor: "#ff7f41" },
};
